import { render, staticRenderFns } from "./PurchasePlanList.vue?vue&type=template&id=d5d7fedc&scoped=true&"
import script from "./PurchasePlanList.vue?vue&type=script&lang=js&"
export * from "./PurchasePlanList.vue?vue&type=script&lang=js&"
import style0 from "./PurchasePlanList.vue?vue&type=style&index=0&id=d5d7fedc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d7fedc",
  null
  
)

export default component.exports